module.exports = __webpack_public_path__ + "static/media/Done.1a501ede.svg";